import Marionette from 'backbone.marionette';
import queryString from 'query-string';
import LoginView from '../../views/Login';
import { LoginOldView, Error404View } from '../../../../core/views';
import { HomeView } from '../../views';
import Radio from "backbone.radio";
// import News from "../../../NRL_Fantasy/collections/News";

const channelUserModals = Radio.channel( 'userModals' );

export default class HomeController extends Marionette.Object {

	get mainRegion(){
		return this.getOption('rootView').getRegion('main');
	}

	home() {
		// Get url params
		const params = queryString.parse(location.search);
		let homeView;
		if (params.code) {
			homeView = new LoginView({
				nrl_account_code: params.code,
				redirect_uri: params.state
			});
		}
		else {
			homeView = new HomeView({
				// news: new News()
			});
		}
		if (params.returning === 'true') {
			channelUserModals.trigger('show:activation:modal')
		}
		this.mainRegion.show(homeView);
	}

	registration() {
		console.log('Registration page');
	}

	login() {
		this.mainRegion.show(new LoginOldView());
	}

	notFound() {
		this.mainRegion.show(new Error404View());
	}
}